class ProductUpsells extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.tabList = this.els.tabs?.element
    this.tabs = this.els.tab?.elements || []
    this.panels = this.els.panel?.elements || []
  }

  connectedCallback () {
    super.connectedCallback?.()

    const pairWithPanel = this.querySelector('[data-pair-with-url]')

    if (!pairWithPanel) return

    window.dataLayer = window.dataLayer || []

    window.dataLayer.push({
      event: 'pdp_pair_it_with',
      url: pairWithPanel.dataset.pairWithUrl,
      item: pairWithPanel.dataset.pairWithTitle,
    })
  }

  setupListeners () {
    super.setupListeners()

    if (!this.tabList) return

    this.listeners.add(this.tabList, 'keydown', (e) => {
      const currentTab = e.target
      const currentIndex = this.tabs.indexOf(currentTab)

      if (currentIndex === -1) return

      let newIndex = 0

      switch (e.key) {
        case 'ArrowRight':
          newIndex = (currentIndex + 1) % this.tabs.length
          break
        case 'ArrowLeft':
          newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length
          break
        case 'Home':
          newIndex = 0
          break
        case 'End':
          newIndex = this.tabs.length - 1
          break
        default:
          return
      }

      e.preventDefault()
      e.stopPropagation()
      this.tabs[newIndex].focus()
    })

    this.tabs.forEach((tab) => {
      this.listeners.add(tab, 'click', (e) => {
        this.showTab(e.target)
      })

      this.listeners.add(tab, 'keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          e.stopPropagation()
          this.showTab(e.target)
        }
      })
    })
  }

  showTab (targetTab) {
    for (const tab of this.tabs) {
      if (tab === targetTab) continue

      tab.setAttribute('aria-selected', false)
      tab.tabIndex = -1
    }

    targetTab.setAttribute('aria-selected', true)
    targetTab.tabIndex = 0

    const targetPanel = document.getElementById(
      targetTab.getAttribute('aria-controls'),
    )

    for (const panel of this.panels) {
      if (panel === targetPanel) continue

      panel.hidden = true
    }

    targetPanel.hidden = false
  }
}

if (!customElements.get('product-upsells')) {
  customElements.define('product-upsells', ProductUpsells)
}
